export const MAP_FLY_DURATION = 1000;
export const MAP_FLY_EASING_FUNCTION = (t: number) =>
    t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
